import Vue from 'vue';

export let notifyEvent = new Vue();

export class Notify {
    title = '';
    info = '';
    message = '';
    options = {};

    /**
     * constructor a Notify instance
     *
     * @param {string|object} params
     */
    constructor(params) {
        if (typeof params === 'string') this.message = `${params}`;
        if (typeof params === 'object') {
            let {title = '', info = '', message = ''} = params;
            this.title = `${title}`;
            this.info = `${info}`;
            this.message = `${message}`;
        }
        for (let index in params) {
            this.options[index] = params[index];
        }
        if (this.title === '') return false;
    }
}

export default {
    install: (Vue, options) => {
        /**
         * Pushing a message to notification's list.
         *
         * @param {string|object} params - string will be the message, object can specify a title, info and the message.
         */
        Vue.notify = (params) => {
            notifyEvent.$emit('add', new Notify(params))
        }
    }
}
